import { useMemo } from 'react';
import { matchPath } from 'react-router';

import type { Props as NavItemProps } from './StarsNavItem';

interface Props {
  indent?: number;
  path?: string;
  pathname: string;
  subNav?: NavItemProps[];
}

const useSectionActive = ({ indent, path = '', subNav, pathname }: Props): boolean => {
  const isSectionActive = useMemo(() => {
    if (typeof indent !== 'undefined' && indent > 0) return false;

    if (!subNav) {
      return !!matchPath(pathname, { path });
    }

    return subNav.some((navItem: NavItemProps) => matchPath(pathname, { path: navItem.path }));
  }, [pathname, path, subNav, indent]);

  return isSectionActive;
};

export default useSectionActive;
